import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import ConstantsUtil from '../../../../context/constantsUtil'
import GeneralServices from '../../../../app/service/generalServices'
import { Button } from 'primereact/button'
import ExpansionTableButton from '../../DRE/expansionTableButton'
import { classNames } from 'primereact/utils'
import DRECompetenciaMensalDetalhamentoDialog from './DRECompetenciaMensalDetalhamentoDialog'
import AuthService from '../../../../app/service/authService'


class DRECompetenciaMensalTable extends React.Component {

    constructor(){
        super()
        this.ref = React.createRef()
        this.dreCompetenciaMensalDetalhamentoDialogRef = React.createRef()
        this.generalServices = new GeneralServices()
    }

    state = {
        expanded: false,
        grupoDetalhamento: '',
        itemDetalhamento: '',

        visibleDetalhamentoDialog: false,

        isExportacaoAutomatica: false,
        listToExport: [],
        listToExportProdutos: [],
        indexExportacao: null,

    }

    componentDidMount(){
        this.scroll()
    }

    scroll = async () => {
        await this.generalServices.sleep(300)
        if(
            this.props.dreCompetenciaGrupoMensal.titulo.includes(ConstantsUtil.receitaBrutaLabel)
            && this.ref.current
        )
        {
            this.ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            // this.ref.current.scrollIntoView();
        }
    }


    getValorTotalSeverity = () => {
        switch (this.props.dreCompetenciaGrupoMensal.tipo) {

            case ConstantsUtil.DRECompetenciaTipoEntradaLabel:
              return "success"

            case ConstantsUtil.DRECompetenciaTiposSaidaLabel:
                return "danger"

            case ConstantsUtil.DRECompetenciaTiposFormulaLabel:
                if(this.props.dreCompetenciaGrupoMensal.total >= 0){
                    return "success"
                }
                else{
                    return "danger"
                }

        }
    }

    handleClickValorTotalHeader = () => {
        if(this.props.dreCompetenciaGrupoMensal.habilitaDetalhamento) {
            if(
                this.props.dreCompetenciaGrupoMensal.total
                &&
                (
                    !this.props.dreCompetenciaGrupoMensal.dreCompetenciaItemList
                    || this.props.dreCompetenciaGrupoMensal.dreCompetenciaItemList.length == 0
                )
            ){
                /*
                Só deve abrir detalhamento a partir do Valor Total no Header se for um grupo com detalhamento habilitado
                e se não tiver lista de itens.
                Se tiver lista de itens, o detalhamento só será possivel ao clicar em cada item.
                */
                this.viewLancamentos(this.props.dreCompetenciaGrupoMensal, null)
            }
            else if(this.props.dreCompetenciaGrupoMensal.total)
            {
                this.toggleExpansionTable()
            }
        }
    }

    viewLancamentos = async (grupo, rowData, isExportacaoAutomatica = false, index) => {
        // console.log("view grupo: ", grupo)
        // console.log("view rowData: ", rowData)
        await this.setState({
            grupoDetalhamento: grupo,
            itemDetalhamento: rowData,
            isExportacaoAutomatica,
            indexExportacao: index
        })
        // console.log("viewLancamentos state item: ", this.state.itemDetalhamento)
        this.setState({visibleDetalhamentoDialog: true})
    }

    hideDetalhamentoDialog = async () => {
        // console.log("hideDetalhamentoDialog")
        await this.setState({
            visibleDetalhamentoDialog: false,
            isExportacaoAutomatica: false,
            // grupoDetalhamento: null,
            // itemDetalhamento: null,
            // indexExportacao: 0
        })
    }

    toggleExpansionTable = async () => {
        await this.setState({expanded: !this.state.expanded})
        await this.setState({selectedNome: ''})
        await this.setState({selectedTotal: ''})
        // await this.setState({selectedPorcentagem: ''})
        if(this.props.dt && this.props.dt.current){
            this.props.dt.current.reset(); //reseta filtro
        }
    }

    hasExpansion = () => {
        return (this.props.dreCompetenciaGrupoMensal.dreCompetenciaItemList && this.props.dreCompetenciaGrupoMensal.dreCompetenciaItemList.length > 0)
    }

    filterZeroValues = () => {
        if(this.props.filterZeroValues){
            return this.props.dreCompetenciaGrupoMensal.dreCompetenciaItemList.filter(item => item.valor != 0)
        }
        return this.props.dreCompetenciaGrupoMensal.dreCompetenciaItemList
    }

    getTitle = (rowData) => {
        let nome = rowData.nome
        if(rowData.isProduto){
            let tipoProduto = nome.split(" - ")[1]
            return ConstantsUtil.getDetalhamentoOrigemLancamentoTipoProduto(tipoProduto)
        }
        return ConstantsUtil.getDetalhamentoOrigemLancamentoGrupoDeLancamento(nome);
    }

    exportLancamentosIndividuais = async () => {

        console.log("renderExportExcelButton: ", this.props.dreCompetenciaGrupoMensal)
        this.setState({
            listToExport: [],
            listToExportProdutos: [],
        })

        this.callBackListToExportDetalhamento([], -1, ConstantsUtil.exportListProvisaoNormal)

    }

    callBackListToExportDetalhamento = async (receivedList, index, tipoLista, finish = false) => {

        console.log("callBackListToExportDetalhamento: ", index, receivedList)

        AuthService.startBlockUi()

        console.log("\n\n")

        if(
            this.dreCompetenciaMensalDetalhamentoDialogRef
            && this.dreCompetenciaMensalDetalhamentoDialogRef.current
            && (receivedList && receivedList.length > 0)
        ){
            console.log("chamou hide por current callBackListToExportDetalhamento")
            this.dreCompetenciaMensalDetalhamentoDialogRef.current.hideDialog()
        }

        if(receivedList && receivedList.length > 0){

            let listToExport = []
            let listToExportProdutos = []
            
            switch(tipoLista){

                case ConstantsUtil.exportListProvisaoNormal:
                    listToExport = this.state.listToExport
                    listToExport.push(receivedList)
                    this.setState({listToExport})
                    break;

                case ConstantsUtil.exportListProvisaoProdutos:
                    listToExportProdutos = this.state.listToExportProdutos
                    listToExportProdutos.push(receivedList)
                    this.setState({listToExportProdutos})                    
                    break;
                
            }

            console.log("lista concatenada provisão normal: ", listToExport)
            console.log("lista concatenada provisão produtos: ", listToExportProdutos)


        }

        // console.log("antes do size: ", this.props.dreCompetenciaGrupoMensal)

        //this.props.dreCompetenciaGrupoMensal.dreCompetenciaItemList é null no caso do CMV.
        let dreCompetenciaItemList = this.props.dreCompetenciaGrupoMensal.dreCompetenciaItemList
        let size = dreCompetenciaItemList && dreCompetenciaItemList.length > 0 ? dreCompetenciaItemList.length : 1 //Passa 1 no caso do CMV.
        if(!dreCompetenciaItemList){
            dreCompetenciaItemList = []
        }
        
        index++
        console.log("index ", index, ", size: ", size)

        if(index < size){
            console.log("buscando index ", index)
            let item = dreCompetenciaItemList[index]
            console.log("item do index: ", item ? item.nome : item)
            if(item && !item.valor){
                console.log("item sem valor, pulando")
                this.callBackListToExportDetalhamento([], index, tipoLista)
            }
            else if(this.deveIgnorarPeloTipoLista(item, tipoLista)){
                console.log("item tipoLista diferente, pulando")
                this.callBackListToExportDetalhamento([], index, tipoLista)
            }
            else{
                console.log("viewLancamentos: ", item ? item.nome : item)
                this.viewLancamentos(this.props.dreCompetenciaGrupoMensal, item, true, index)
            }
        }

        else{

            let count = this.countItensAExportar(dreCompetenciaItemList, tipoLista)

            let tamanhoListToExport = this.getTamanhoListaConstruidaAExportar(tipoLista)
            
            console.log("\n\n")
            console.log("lista final provisõss normais: ", this.state.listToExport)
            console.log("lista final provisõss produtos: ", this.state.listToExportProdutos)
            console.log("qtd listas finais: ", tamanhoListToExport)
            console.log("qtd total de itens: ", count)

            if(count == 0 || count == tamanhoListToExport){
                
                this.exportList(tipoLista)

                if(ConstantsUtil.exportListProvisaoNormal === tipoLista){
                    console.log("\n\n")
                    this.callBackListToExportDetalhamento([], -1, ConstantsUtil.exportListProvisaoProdutos)
                }

                if(ConstantsUtil.exportListProvisaoProdutos === tipoLista){
                    AuthService.stopBlockUi()
                }
            }
            else{
                console.log("Size maior, mas aguardando")
            }

        }

    }

    countItensAExportar = (dreCompetenciaItemList, tipoLista) => {
        
        let listaFiltrada = dreCompetenciaItemList.filter(item => {
            switch(tipoLista){
                case ConstantsUtil.exportListProvisaoNormal:
                    return item.valor && !item.isProduto

                case ConstantsUtil.exportListProvisaoProdutos:
                    return item.valor && item.isProduto
                
                default:
                    return item.valor
            }
        })

        let count = listaFiltrada.length
        return count

    }

    getTamanhoListaConstruidaAExportar = (tipoLista) => {

        switch(tipoLista){
            case ConstantsUtil.exportListProvisaoNormal:
                return this.state.listToExport.length

            case ConstantsUtil.exportListProvisaoProdutos:
                return this.state.listToExportProdutos.length
        }        

    }

    deveIgnorarPeloTipoLista = (item, tipoLista) => {

        if(!item){
            return false
        }
        
        if(ConstantsUtil.exportListProvisaoNormal === tipoLista && item.isProduto){
            /*
            tipoLista é PROVISAO_NORMAL e o item é de produto.
            Manda pular esse
            */
            return true
        }
        
        if(ConstantsUtil.exportListProvisaoProdutos === tipoLista && !item.isProduto){
            /*
            tipoLista é PROVISAO_PRODUTOS e o item não é de produto.
            Manda pular esse
            */
            return true
        }

        return false
    }

    linearizaListasEOrdenaExportacao = (matriz, sortField) => {

        let finalListToExport = []
        matriz.forEach(subListToExport => {
            finalListToExport.push(...subListToExport)
        })

        finalListToExport.sort((a, b) => {
            const [diaA, mesA, anoA] = a[sortField].split('/');
            const [diaB, mesB, anoB] = b[sortField].split('/');

            const dataA = new Date(anoA, mesA - 1, diaA);
            const dataB = new Date(anoB, mesB - 1, diaB);

            // ordem crescente
            return dataA - dataB;
        });

        return finalListToExport

    }

    exportList = (tipoLista) => {

        let listToExport = []
        let sortField = ''
        let fileLabel = ''

        switch(tipoLista){
            case ConstantsUtil.exportListProvisaoNormal:
                listToExport = this.state.listToExport
                sortField = "Data de Lançamento"
                fileLabel = 'Lançamentos Individuais'
                break;

            case ConstantsUtil.exportListProvisaoProdutos:
                listToExport = this.state.listToExportProdutos
                sortField = "Data de Entrada"
                fileLabel = 'Produtos'
                break;
        }

        let finalListToExport = this.linearizaListasEOrdenaExportacao(listToExport, sortField)

        if(listToExport && listToExport.length > 0){
            console.log("fileLabel: ", fileLabel)
            console.log("finalListToExport: ", finalListToExport)
            console.log("this.props.dreCompetenciaGrupoMensal.titulo: ", this.props.dreCompetenciaGrupoMensal.titulo)
            GeneralServices.exportExcel(finalListToExport, "Vendas", `${this.props.dreCompetenciaGrupoMensal.titulo} - ${fileLabel}`)
        }        


    }

    // exportaLista = (list, fileLabel) => {
    //     if(list && list.length > 0){
    //         console.log("fileLabel: ", fileLabel)
    //         console.log("list: ", list)
    //         // GeneralServices.exportExcel(list, "Vendas", `${GeneralServices.getNomeSemSimboloGrupoDre(this.props.dreCompetenciaGrupoMensal.titulo)} - ${fileLabel}`)
    //     }
    // }

    render() {

        const renderExpansionButton = () => {
            if(this.hasExpansion()){
                return (
                    <ExpansionTableButton
                        expanded={this.state.expanded}
                        toggleExpansionTable={this.toggleExpansionTable}
                    />                    
                )
            }

        }

        const renderViewLancamentosLink = (grupo, rowData) => {
            const valor = rowData.valor
            const valorFormatado = GeneralServices.showFormattedIfNotNull(valor, true)
            const cond1 = valor !== 0
            const cond2 = grupo.habilitaDetalhamento
            if( cond1 && cond2) {
                const classes = classNames({
                    // 'superavitValue': valor >= 0,
                    // 'deficitValue': valor < 0,
                    'linkValue': true
                    
                });
                return(
                    <a 
                        className={classes}
                        // href='/DRE'
                        onClick={() => this.viewLancamentos(grupo, rowData)}
                    >
                        {valorFormatado}
                    </a>
                )
            }
            else{
                return(
                    <>
                        {valorFormatado}
                    </>
                )
            }
        }

        const renderTable = () => {
            if(!this.state.expanded || !this.props.dreCompetenciaGrupoMensal.dreCompetenciaItemList){
                return <></>;
            }
            return (
                <DataTable
                    ref={this.dt}
                    // value={this.props.dreCompetenciaGrupoMensal.dreCompetenciaItemList}
                    value={this.filterZeroValues()}
                    className="p-datatable-sm small-font"
                    // rowClassName={this.saldoClass}
                    autoLayout
                    rowHover
                    showGridlines
                    // selection={this.state.selectedContasBancaria}
                    // onSelectionChange={this.handleSelectionChange}
                    scrollable
                    style={{ maxWidth: '100vw'}}
                    scrollHeight="500px"
                    frozenWidth={ConstantsUtil.widthColumNomeSaldoDreConsolidado}
                    loading={this.props.loading}
                    dataKey="id"
                    emptyMessage="Nenhum Resultado encontrado."
                    // paginator rows={ConstantsUtil.initialTableQuantityOption}
                    // paginatorTemplate={GeneralServices.tablePaginatorTemplate(ConstantsUtil.initialTableQuantityOption, this.props.list ? this.props.list.length : '')}
                    // currentPageReportTemplate="Mostrando de {first} ao {last} de {totalRecords} Tipos de Pagamento"
                >

                    <Column field="nome" header="Nome"
                        style ={ {width: ConstantsUtil.widthColumNomeDreConsolidado} }
                        frozen
                        sortable
                        body = { (rowData, rowIndex) => {
                            const uniqueId = `${rowIndex.rowIndex}`;
                            // console.log("rowIndex: ", rowIndex)
                            return (
                                <div
                                    style ={ {
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                    } }
                                    // title={rowData.nome}
                                    title={this.getTitle(rowData)}
                                >
                                <span id={uniqueId}>{rowData.nome}</span>
        
                                </div>                        
                            )
                        }}
                    />

                    <Column field="valor" header="Valor"
                        style ={ {width: ConstantsUtil.widthColumDreConsolidado} }
                        sortable
                        // body = {rowData => GeneralServices.showFormattedIfNotNull(rowData.valor, true)}
                        body = {rowData => {
                            return (
                                <div className='right-align'>
                                    {renderViewLancamentosLink(this.props.dreCompetenciaGrupoMensal, rowData)}
                                </div>
                            )
                        }}
                    />

                    <Column field="porcentagem" header="Porcentagem"
                        style ={ {width: ConstantsUtil.widthColumDreConsolidado} }
                        sortable
                        // body = {rowData => `${rowData.porcentagem}%`}
                        body = {rowData => {
                            return (
                                <div className='right-align'>
                                    {`${rowData.porcentagem}%`}
                                </div>
                            )
                        }}                        
                    />            

                </DataTable>
            )
        }

        const renderDetalhamentoDialog = () => {
            return (
                <DRECompetenciaMensalDetalhamentoDialog
                    ref={this.dreCompetenciaMensalDetalhamentoDialogRef}
                    visible = {this.state.visibleDetalhamentoDialog}
                    selectedEmpresas={this.props.selectedEmpresas}
                    unificar={this.props.unificar}
                    hideDialog = {this.hideDetalhamentoDialog}
                    dataInicial = {this.props.dataInicial}
                    dataFinal = {this.props.dataFinal}
                    grupo = {this.state.grupoDetalhamento}
                    item = {this.state.itemDetalhamento}
                    searchAllDRE={this.props.searchAllDRE}
                    tiposProdutosDescricoesCMV={this.props.tiposProdutosDescricoesCMV}
                    isExportacaoAutomatica={this.state.isExportacaoAutomatica}
                    indexExportacao={this.state.indexExportacao}
                    callBackListToExportDetalhamento={this.callBackListToExportDetalhamento}
                />
            )
        }

        const renderExportExcelButton = () => {
            if(this.props.dreCompetenciaGrupoMensal.tipo === ConstantsUtil.DRECompetenciaTiposSaidaLabel)
            return (
                <Button
                    // label={"Exportar"}
                    icon="pi pi-file-excel"
                    className={`small-font p-button-success`}
                    style={{maxHeight: '10px', minWidth: '2rem', marginLeft: '10px'}}
                    tooltip={ConstantsUtil.exportXlsxLabel}
                    onClick={this.exportLancamentosIndividuais}
                />
            )
        }

        return(
            <div
                className='borda'
                // style={{marginTop: '0.8rem'}}
            >


                <div
                    ref={this.ref}
                    className = "card-header header-small-height"
                >
                <div className='col-md-12'>
                    

                    <div className='row'>
                        {renderExpansionButton()}
                        <div className='col-md-4'>
                            <h5 className='small-font-size'>{this.props.dreCompetenciaGrupoMensal.titulo}</h5>            
                        </div>

                        {/* <div className={`col-md-${this.hasExpansion() ? "4" : "5"}`}> */}
                        <div
                            className="col-md-4"
                            style={
                                this.hasExpansion() ?
                                {}
                                : {marginLeft: '1.2em'}
                            }
                        >
                        </div>
                        
                        <div
                            className='col-md-3'
                            style={{ display: 'flex', justifyContent: 'flex-start' }}
                        >
                            <Button
                                label={`Valor Total: ${GeneralServices.showFormattedIfNotNull(this.props.dreCompetenciaGrupoMensal.total , true)}`}
                                className={`small-font p-button-${this.getValorTotalSeverity()}`}
                                style={{maxHeight: '10px', minWidth: '12rem'}}
                                onClick={this.handleClickValorTotalHeader}
                            />

                            <Button
                                // label={`${ Math.abs(this.props.dreCompetenciaGrupoMensal.porcentagem)}%`}
                                label={ this.props.dreCompetenciaGrupoMensal.porcentagem ? `${this.props.dreCompetenciaGrupoMensal.porcentagem}%` : "0%"}
                                className={`small-font p-button-${this.getValorTotalSeverity()} right-button`}
                                style={{maxHeight: '10px', minWidth: '5rem'}}
                                // onClick={this.handleClickValorTotalHeader}
                            />

                            {renderExportExcelButton()}

                        </div>

                    </div>

                    
                </div>
                </div>

                {renderTable()}

                {renderDetalhamentoDialog()}

            </div>
        )
    }

}

export default DRECompetenciaMensalTable